import React from 'react';
import PortfolioRow from '../components/common/PortfolioRow';
import './PageStyles.css';

const LabsPage: React.FC = () => {
    // Coming soon state
    const isComingSoon = true;

    const labItems = [
        {
            title: 'AI Chatbot',
            description: 'Experimental chatbot interface using local LLMs for private conversations.',
            link: '/prototypes/chatbot'
        },
        {
            title: 'Crypto Dashboard',
            description: 'Real-time cryptocurrency visualization dashboard using WebSocket data.',
            link: '/prototypes/crypto'
        }
    ];

    return (
        <div className="page-container">
            <div className="container">
                <h1 className="page-title">Labs</h1>
                <p className="page-subtitle">Experimental prototypes, concepts, and works in progress.</p>

                {isComingSoon ? (
                    <div className="coming-soon-container">
                        <h3 className="coming-soon-text">Coming Soon</h3>
                    </div>
                ) : (
                    <div className="portfolio-list-container">
                        {labItems.map((item, index) => (
                            <PortfolioRow
                                key={index}
                                title={item.title}
                                description={item.description}
                                link={item.link}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default LabsPage;
